import type { View } from "@-/com.npmjs.react-native";
import {
  MorphemeInfoPanelAccordionScrollControlContext,
  type MorphemeInfoPanelAccordionScrollView,
} from "#morpheme-info-panel-accordion-scroll-control";
import { type ReactNode, useCallback, useMemo, useRef, type RefObject } from "react";

export function MorphemeInfoPanelAccordionScrollControlProvider({
  children,
  scrollRef,
  scrollYRef: scrollYRefProp,
}: {
  children?: ReactNode;
  scrollRef: RefObject<MorphemeInfoPanelAccordionScrollView | null>;
  scrollYRef?: RefObject<number>;
}) {
  const ownScrollYRef = useRef(0);
  const scrollYRef = scrollYRefProp ?? ownScrollYRef;

  const scrollHeaderIntoView = useCallback(
    (headerRef: RefObject<View | null>) => {
      const scroll: MorphemeInfoPanelAccordionScrollView | null = scrollRef.current;
      const header = headerRef.current;
      if (scroll == null || header == null) {
        return;
      }

      const innerView = scroll.getInnerViewRef?.();
      if (innerView == null) {
        return;
      }

      header.measureLayout(
        innerView,
        (_x, y) => {
          scroll.scrollTo({ animated: true, y });
        },
        () => {},
      );
    },
    [scrollRef],
  );

  const value = useMemo(
    () => ({ scrollHeaderIntoView, scrollRef, scrollYRef }),
    [scrollRef, scrollHeaderIntoView, scrollYRef],
  );

  return (
    <MorphemeInfoPanelAccordionScrollControlContext.Provider value={value}>
      {children}
    </MorphemeInfoPanelAccordionScrollControlContext.Provider>
  );
}
